import { render, staticRenderFns } from "./Interneerfassungsliste.vue?vue&type=template&id=2fa43d44"
import script from "./Interneerfassungsliste.vue?vue&type=script&lang=js"
export * from "./Interneerfassungsliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports